module.exports = __webpack_public_path__ + "img/circle.cb070543.svg";